// extracted by mini-css-extract-plugin
module.exports = {"frag":"Tab2_frag___1yln"};